import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';
import { formDetails as StepFiveFormDetails } from '../step-five';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 6',
    eventLabel: 'Asses My Finances - What I Owe'
};

export const formName = Routes.STEPSIX;

export const formDetails = {
    key: 'owing',
    title: 'What I owe',
    formName,
    totalKey: 'currentOwing',
    fields: {
        mortgages: {
            label: 'Mortgages'
        },
        loans: {
            label: 'Loans/Lines of Credit',
        },
        creditCard: {
            label: 'Credit Cards'
        }
    }
};
const minValue = 0;

class StepSixForm extends Component {
    calculateTotal() {
        const {
            formValues: {
                [formDetails.totalKey]: removedTotal,
                ...values
            } = {}
        } = this.props;
        return Object.values(values).reduce((total, val) => total + val);
    }

    componentDidUpdate() {
        const {
            changeFieldValue
        } = this.props;
        changeFieldValue(formDetails.totalKey, this.calculateTotal());
    }

    render() {
        const {
            formValues: {
                [formDetails.totalKey]: total = 0
            } = {}
        } = this.props;
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key =>
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            prefix='$'
                            format={numberWithCommas}
                            parse={parseNumberWithCommas}
                            component={RenderInput}
                        />
                    )
                }
                <Field
                    type='text'
                    name='currentOwing'
                    label='Total'
                    prefix='$'
                    readOnlyValue={numberWithCommas(total)}
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
            </form>
        );
    }
}

const formValues = getFormValues(formDetails.formName);
const StepFiveForm = formValueSelector(StepFiveFormDetails.formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    whatIHaveTotal: StepFiveForm(state, StepFiveFormDetails.totalKey),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value))
});

StepSixForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPSEVEN}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepSixForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepSixForm));
